import GetData from '../../RestAPI/getDataService';
import FD from '../../RestAPI/fetchData';
import config from '../../config/App_data';

/* 
   I am using the 'question' key in the API functions. 
   Please disregard it,
   as these API calls originate from the Question Bank common component, 
   which necessitates its usage
*/

const retrieveVideos = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/videos/all-videos`, data);
};
const saveLastViewedVideo = async data => {
  return await FD.callAPI(`${config.backend_api}/exams/cfa/videos/last-video-viewed`, data);
};
const fetchSavedQuestion = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/videos/save`, {
    videoId: data.video_id,
    ...data,
  });
};
const saveQuestion = async data => {
  return await FD.callAPI(`${config.backend_api}/exams/cfa/videos/save`, {
    videoId: data.video_id,
    ...data,
  });
};
const deleteSavedQuestion = async data => {
  return await FD.callAPI(`${config.backend_api}/exams/cfa/videos/unsave`, {
    videoId: data.video_id,
    ...data,
  });
};
const mutateReportVideo = async data => {
  return await FD.callAPI(`${config.backend_api}/exams/cfa/videos/report`, data);
};
module.exports = {
  retrieveVideos,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  mutateReportVideo,
  saveLastViewedVideo,
};



// WEBPACK FOOTER //
// ./src/views/Videos/PlayList/ApiService.js